import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import api from "../../services/api";
import EnderecoForm from "../../components/EnderecoForm";
import { Container } from "../Autocadastro/styles/styles";
import "../Autocadastro/styles/global.css";

// ===========================================================================
// COLETA AVULSA — página pública /coleta/:token
//
// O operador cunha o link no admin e manda por WhatsApp; o formando abre no
// celular e preenche UMA coisa. Sem login, sem conta de portal — que é o ponto:
// boa parte de quem precisa preencher endereço nem tem usuário no portal.
//
// NÃO é impersonação: a página não cria sessão nem dá acesso a nada além do
// campo daquele tipo. O aluno vive DENTRO do token (HMAC, validado na API),
// nunca no corpo — por isso nada aqui identifica formando.
//
// Uso único e validade curta: o link morre ao ser gravado com sucesso, e
// expira em 1h. Erro de validação NÃO queima o link (senão a pessoa erra o CEP
// e fica sem saída).
// ===========================================================================

const CAIXA = {
  maxWidth: 460,
  margin: "0 auto",
  padding: "28px 20px",
  textAlign: "center",
};

function Aviso({ titulo, texto }) {
  return (
    <Container>
      <div style={CAIXA}>
        <h1 style={{ marginBottom: 12 }}>{titulo}</h1>
        <p style={{ color: "#555", lineHeight: 1.5 }}>{texto}</p>
      </div>
    </Container>
  );
}

function brl(v) {
  try {
    return Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(v);
  } catch (e) {
    return "R$ " + Number(v || 0).toFixed(2);
  }
}

function dataBR(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10).split("-");
  return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : String(iso);
}

const FORMATO_LABEL = {
  cartao: "Cartão",
  boleto: "Boleto",
  misto: "Boleto + Cartão",
  misto_pix: "Pix + Cartão",
  pix: "Pix",
};

// ---------------------------------------------------------------------------
// Escolha da CONDIÇÃO. Diferente do endereço, isto gera parcelas e compromisso
// financeiro — por isso tem tela de CONFIRMAÇÃO antes de aplicar, mostrando
// valor e vencimentos. Endereço é reversível; plano de pagamento não.
// ---------------------------------------------------------------------------
function EscolhaCondicao({ dados, enviar, onPronto }) {
  const [escolhida, setEscolhida] = useState(null);
  const [confirmando, setConfirmando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);

  const lista = dados.condicoes || [];
  const cond = lista.find((c) => c.id === escolhida) || null;

  async function confirmar() {
    if (!cond || enviando) return;
    setEnviando(true);
    setErro(null);
    try {
      await enviar({ condicao: cond.id });
      onPronto();
    } catch (e) {
      const d = e && e.response && e.response.data;
      setErro((d && d.erro) || "Não foi possível registrar sua escolha.");
      setEnviando(false);
      setConfirmando(false);
    }
  }

  if (confirmando && cond) {
    return (
      <Container>
        <div style={{ ...CAIXA, textAlign: "left" }}>
          <h1 style={{ textAlign: "center" }}>Confirme sua escolha</h1>
          <p style={{ color: "#555", textAlign: "center" }}>
            Depois de confirmar, este plano não pode ser trocado por aqui.
          </p>
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: 14,
              margin: "16px 0",
            }}
          >
            <strong>{cond.nome}</strong>
            <div style={{ color: "#555", fontSize: 14, marginTop: 4 }}>
              {FORMATO_LABEL[cond.formato] || cond.formato} ·{" "}
              <strong>{brl(cond.valor)}</strong>
            </div>
            {Array.isArray(cond.preview) && cond.preview.length > 0 && (
              <ul style={{ marginTop: 10, paddingLeft: 18, fontSize: 14 }}>
                {cond.preview.map((l, i) => (
                  <li key={i} style={{ marginBottom: 2 }}>
                    {brl(l.parcvalor)} em {dataBR(l.parcvencimento)}
                    {l.maxParcelas ? ` (até ${l.maxParcelas}x)` : ""}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {erro && <span className="errors-autocad">{erro}</span>}
          <button
            className="autocad"
            style={{ width: "100%", padding: 12, cursor: "pointer" }}
            disabled={enviando}
            onClick={confirmar}
          >
            {enviando ? "Confirmando…" : "Confirmar este plano"}
          </button>
          <button
            style={{
              width: "100%",
              padding: 10,
              marginTop: 8,
              background: "none",
              border: "none",
              color: "#555",
              cursor: "pointer",
            }}
            disabled={enviando}
            onClick={() => setConfirmando(false)}
          >
            Voltar e escolher outro
          </button>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div style={{ ...CAIXA, textAlign: "left" }}>
        <h1 style={{ textAlign: "center" }}>
          {dados.nome ? `${dados.nome}, escolha` : "Escolha"} como quer pagar
        </h1>
        <p style={{ color: "#555", textAlign: "center" }}>
          Selecione uma das opções da sua turma.
        </p>
        {lista.length === 0 && (
          <p style={{ color: "#555" }}>
            Nenhuma opção disponível no momento. Fale com a produtora.
          </p>
        )}
        {lista.map((c) => (
          <label
            key={c.id}
            style={{
              display: "block",
              border:
                escolhida === c.id ? "2px solid #333" : "1px solid #ddd",
              borderRadius: 8,
              padding: 12,
              marginBottom: 8,
              cursor: "pointer",
            }}
          >
            <input
              type="radio"
              name="condicao"
              checked={escolhida === c.id}
              onChange={() => setEscolhida(c.id)}
              style={{ marginRight: 8 }}
            />
            <strong>{c.nome}</strong>
            <div style={{ color: "#555", fontSize: 14, marginTop: 4 }}>
              {FORMATO_LABEL[c.formato] || c.formato} · {brl(c.valor)}
            </div>
            {c.descricao && (
              <div style={{ color: "#777", fontSize: 13, marginTop: 4 }}>
                {c.descricao}
              </div>
            )}
          </label>
        ))}
        {erro && <span className="errors-autocad">{erro}</span>}
        <button
          className="autocad"
          style={{ width: "100%", padding: 12, cursor: "pointer" }}
          disabled={!cond}
          onClick={() => setConfirmando(true)}
        >
          Continuar
        </button>
      </div>
    </Container>
  );
}

// ---------------------------------------------------------------------------
export default function Coleta() {
  const { token } = useParams();
  const [estado, setEstado] = useState("carregando");
  const [dados, setDados] = useState(null);
  const [motivo, setMotivo] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data } = await api.get(`/coleta/${token}`);
        if (!cancel) {
          setDados(data);
          setEstado("form");
        }
      } catch (e) {
        const d = e && e.response && e.response.data;
        if (!cancel) {
          setMotivo((d && d.code) || "INVALIDO");
          setEstado("invalido");
        }
      }
    })();
    return () => {
      cancel = true;
    };
  }, [token]);

  const enviar = (corpo) => api.post(`/coleta/${token}`, corpo);

  if (estado === "carregando") {
    return <Aviso titulo="Carregando…" texto="Um instante." />;
  }

  if (estado === "invalido") {
    if (motivo === "EXPIRADO") {
      return (
        <Aviso
          titulo="Este link expirou."
          texto="Por segurança os links valem por pouco tempo. Peça um novo para quem te enviou — leva alguns segundos."
        />
      );
    }
    if (motivo === "USADO") {
      return (
        <Aviso
          titulo="Este link já foi usado."
          texto="Se precisar corrigir alguma informação, peça um novo link para a produtora."
        />
      );
    }
    return (
      <Aviso
        titulo="Link inválido."
        texto="Confira se o endereço foi copiado por inteiro, ou peça um novo para a produtora."
      />
    );
  }

  if (estado === "pronto") {
    return (
      <Aviso
        titulo="Tudo certo!"
        texto={
          dados && dados.tipo === "condicao"
            ? "Seu plano de pagamento foi registrado. Você já pode acompanhar tudo pelo portal do formando."
            : "Seu endereço foi salvo. Não precisa fazer mais nada."
        }
      />
    );
  }

  if (dados.tipo === "endereco") {
    return (
      <Container>
        <EnderecoForm
          enviar={enviar}
          valores={dados.preenchido}
          titulo={
            dados.nome ? `${dados.nome}, precisamos do seu endereço.` : undefined
          }
          rotuloBotao="Salvar endereço"
          aviso="É com ele que emitimos seus boletos e recibos. Leva menos de um minuto."
          onPronto={() => setEstado("pronto")}
        />
      </Container>
    );
  }

  if (dados.tipo === "condicao") {
    return (
      <EscolhaCondicao
        dados={dados}
        enviar={enviar}
        onPronto={() => setEstado("pronto")}
      />
    );
  }

  return (
    <Aviso
      titulo="Não reconhecemos este link."
      texto="Peça um novo para a produtora."
    />
  );
}
